export const frTranslations = {
  app_name: 'Balivernologie',
  nav: {
    home: 'Accueil',
    investigations: 'Nos enquêtes',
    investigators: 'Nos enquêteurs',
    login: 'Connexion',
    register: 'Inscription',
    logout: 'Déconnexion',
    streamerAdmin: 'Admin',
    my_profile: 'Mon profil',
    about: 'À propos',
    theme_toggle_to_dark: 'Basculer vers le thème sombre',
    theme_toggle_to_light: 'Basculer vers le thème clair',
  },
  home: {
    hero_title: 'Démasquer les Balivernes',
    hero_subtitle:
      'Enquêtes collaboratives sur les mensonges politiques, la rhétorique manipulatrice et la désinformation.',
    hero_cta: 'Voir nos enquêtes',
    recent_title: 'Enquêtes Récentes',
    see_more: 'Toutes les Enquêtes',
    no_investigations: 'Aucune enquête pour le moment.',
    manifesto_quote:
      'Quand les croyances et les convictions comptent plus que la réalité factuelle.',
    stats_investigations: 'Enquêtes actives',
    stats_total_investigations: 'Enquêtes au total',
    stats_investigators: 'Enquêteurs',
    stats_closed_investigations: 'Enquêtes terminées',
    carousel_prev: 'Précédent',
    carousel_next: 'Suivant',
    lead_kicker: 'Enquête à la une',
    headlines_title: 'Enquêtes en cours',
    headlines_completed_title: 'Enquêtes terminées',
    secondary_title: 'Enquêtes récentes',
    latest_title: 'Dernières enquêtes',
    category_section_title: '{{category}}',
    see_all: 'Toutes les enquêtes',
    breaking_label: 'Dernière minute',
    empty_state: 'Aucune enquête pour le moment.',
  },
  investigations: {
    title: 'Enquêtes',
    page_title: 'Nos enquêtes',
    search_placeholder: 'Rechercher des enquêtes...',
    filter_category: 'Toutes les catégories',
    filter_category_label: 'Filtrer par catégorie',
    sort_by: 'Trier par',
    sort_date: 'Date',
    sort_title: 'Titre',
    sort_category: 'Catégorie',
    no_results: 'Aucune enquête trouvée.',
    view_details: 'Voir les détails',
    leads_count: '{{count}} piste',
    leads_count_plural: '{{count}} pistes',
    suggest_new: 'Suggérer une enquête',
    suggestions_title: 'Enquêtes suggérées',
    suggestions_subtitle: 'Votez pour les enquêtes que vous souhaitez voir !',
    vote: 'Voter',
    voted: 'Voté',
    votes: '{{count}} votes',
    your_suggestion: 'Votre suggestion',
    suggestion_title_label: 'Titre',
    suggestion_description_label: 'Description (facultatif)',
    suggestion_submit: 'Soumettre la suggestion',
    sort_most_voted: 'Plus votées',
    sort_newest: 'Plus récentes',
    login_to_vote: 'Connectez-vous pour voter',
    login_to_suggest: 'Connectez-vous pour suggérer une enquête',
    suggestion_col_title: 'Titre',
    suggestion_col_by: 'Soumis par',
    suggestion_col_date: 'Date',
    suggestion_col_votes: 'Votes',
    suggestion_empty: 'Aucune suggestion pour le moment.',
    tab_active: 'Enquêtes en cours',
    tab_inactive: 'Enquêtes terminées',
  },
  investigators: {
    page_title: 'Nos enquêteurs',
    page_subtitle: 'Les membres de la communauté qui contribuent aux enquêtes.',
    empty: 'Aucun enquêteur pour le moment.',
    unknown: 'Inconnu',
  },
  investigation_detail: {
    by: 'Par',
    category: 'Catégorie',
    leads: 'Pistes',
    no_leads: 'Aucune piste pour cette enquête.',
    lead_url: 'URL',
    lead_description: 'Description',
    lead_submitted_by: 'Soumis par',
    lead_date: 'Date',
    view_lead: 'Voir les détails',
    add_lead_button: 'Ajouter une piste',
    add_lead_title: 'Soumettre une piste',
    add_lead_title_label: 'Titre',
    add_lead_title_placeholder: 'Ex. : Nouvelle source sur les manipulations climatiques',
    add_lead_description_label: 'Description',
    add_lead_description_placeholder: 'Décrivez brièvement cette piste...',
    add_lead_submit: 'Soumettre la piste',
    add_lead_success: 'Piste ajoutée avec succès !',
    add_lead_login_prompt: 'Connectez-vous pour soumettre une piste',
    not_found_title: 'Enquête introuvable',
    not_found_body: "Cette enquête n'existe pas ou a été supprimée.",
    team_button: "Voir l'équipe",
    team_modal_title: "Équipe d'enquête",
    team_lead_badge: 'Responsable',
    team_empty: 'Aucun membre dans cette équipe.',
    notes_title: 'Analyses et synthèse',
    live_label: 'Live à venir',
    live_at: 'à',
    live_replay_label: 'Replay disponible',
    live_watch_twitch: 'Regarder sur Twitch',
    live_watch_youtube: 'Regarder sur YouTube',
    live_watch_video: 'Voir la vidéo',
    live_video_label: 'Vidéo associée',
    live_watch_replay: 'Voir le Replay',
    lead_drag_handle: 'Faire glisser la piste pour la réordonner',
    lead_reorder_success: 'Ordre des pistes mis à jour',
    lead_reorder_failed: 'Échec de la réorganisation des pistes : {{error}}',
  },
  investigation_form: {
    public_urls_title: 'Adresses publiques',
    public_urls_rename_warning:
      "Modifier le titre (ou sa traduction) change l'adresse dans la langue concernée ; l'ancienne adresse redirige automatiquement.",
    public_url_source_fallback: 'Dérivée du titre source',
    public_url_copy: "Copier l'adresse",
    public_url_copied: 'Adresse copiée',
    public_url_open: 'Ouvrir la page',
  },
  lead_detail: {
    title: 'Détail de la piste',
    description: 'Description',
    date: 'Soumis le',
    not_found_title: 'Piste introuvable',
    not_found_body: "Cette piste n'existe pas ou a été supprimée.",
    badge: 'Piste',
    fallback_title: 'Piste',
    facts: 'Faits',
    no_facts: 'Aucun fait pour cette piste.',
    add_fact_button: 'Ajouter un fait',
    add_fact_title: 'Ajouter un fait',
    fact_title_label: 'Titre',
    fact_title_placeholder: 'Ex. : Article du Monde',
    fact_description_label: 'Description',
    fact_description_placeholder: 'Décrivez brièvement ce fait...',
    fact_url_label: 'URL source',
    fact_url_placeholder: 'https://...',
    fact_no_source_title: 'Fait sans source',
    fact_no_source_message:
      "Vous n'avez indiqué aucune URL source pour ce fait. Il sera enregistré sans référence vérifiable. Voulez-vous continuer ?",
    fact_no_source_cancel: 'Ajouter une source',
    fact_no_source_confirm: 'Enregistrer sans source',
    fact_image_label: 'Image (facultatif)',
    add_fact_submit: 'Ajouter le fait',
    add_fact_success: 'Fait ajouté avec succès !',
    add_fact_login_prompt: 'Connectez-vous pour ajouter un fait',
    fact_delete_confirm: 'Supprimer ce fait ?',
    fact_deleted: 'Fait supprimé',
    fact_delete_failed: 'Impossible de supprimer le fait : {{error}}',
    fact_edit_title: 'Modifier le fait',
    fact_edit_submit: 'Enregistrer les modifications',
    fact_score_validated_label: 'Score validé',
    fact_score_average_label: 'Score moyen',
    fact_score_voters: '{{count}} vote(s)',
    fact_score_none: 'Aucun',
    fact_score_vote_prompt: 'Évaluez le fait',
    fact_score_your_vote: 'Votre évaluation',
    fact_score_validate_updated: 'Score validé mis à jour',
    fact_score_validate_success: 'Score validé enregistré',
    fact_score_validate_error: 'Impossible de mettre à jour le score validé',
    fact_score_validate_button: 'Valider',
    fact_score_validate_label: 'Valider le score',
    fact_score_clear_validated: 'Effacer le validé',
    fact_reset_votes: 'Réinitialiser les votes',
    fact_reset_votes_confirm: 'Réinitialiser tous les votes pour ce fait ?',
    fact_reset_votes_success: 'Votes réinitialisés',
    fact_reset_votes_failed: 'Échec de la réinitialisation des votes',
    fact_updated: 'Fait mis à jour !',
    fact_update_failed: 'Impossible de modifier le fait : {{error}}',
    fact_see_more: 'Voir plus',
    fact_see_less: 'Voir moins',
    fact_source_button: 'Source',
    fact_published: 'Publié',
    fact_unpublished: 'Non publié',
    fact_publish_button: 'Publier',
    fact_publish_success: 'Fait publié avec succès',
    fact_publish_failed: 'Erreur lors de la publication : {{error}}',
    fact_unpublish_button: 'Retirer la publication',
    fact_unpublish_success: 'Fait retiré de la publication',
    fact_unpublish_failed: 'Erreur lors du retrait de la publication : {{error}}',
    fact_drag_handle: 'Déplacer le fait pour le réordonner',
    fact_reorder_success: 'Ordre des faits mis à jour',
    fact_reorder_failed: 'Impossible de réordonner les faits : {{error}}',
    edit_lead: 'Modifier la piste',
    lead_published: 'Publiée',
    lead_unpublished: 'Non publiée',
    lead_publish_button: 'Publier',
    lead_unpublish_button: 'Retirer la publication',
    lead_publish_success: 'Piste publiée avec succès',
    lead_publish_failed: 'Erreur lors de la publication : {{error}}',
    lead_unpublish_success: 'Piste retirée de la publication',
    lead_unpublish_failed: 'Erreur lors du retrait de la publication : {{error}}',
    notes_title: 'Analyses et synthèse',
    source_title: 'Source originale',
    source_add_button: 'Ajouter la source',
    source_edit_button: 'Modifier la source',
    source_delete_confirm: 'Supprimer la source ?',
    source_deleted: 'Source supprimée',
    source_delete_failed: 'Impossible de supprimer la source : {{error}}',
    source_dialog_add_title: 'Ajouter une source',
    source_dialog_edit_title: 'Modifier la source',
    source_title_label: 'Titre *',
    source_title_placeholder: 'Ex : Article du Monde, rapport officiel…',
    source_description_label: 'Description *',
    source_description_placeholder: 'Décrivez brièvement cette source…',
    source_image_label: 'Image (optionnel)',
    source_url_label: 'URL de la source *',
    source_url_placeholder: 'https://...',
    source_submit_add: 'Ajouter',
    source_submit_edit: 'Enregistrer',
    source_saved: 'Source enregistrée',
    source_save_failed: "Impossible d'enregistrer la source : {{error}}",
    source_no_source: 'Aucune source renseignée.',
  },
  auth: {
    login_title: 'Connexion',
    login_subtitle: 'Accédez à votre compte Balivernologie',
    register_title: 'Créer un compte',
    register_subtitle: 'Rejoignez la communauté Balivernologie',
    username: "Nom d'utilisateur",
    email: 'Email',
    password: 'Mot de passe',
    display_name: "Nom d'affichage (facultatif)",
    login_button: 'Se connecter',
    register_button: 'Créer un compte',
    no_account: 'Pas encore de compte ?',
    has_account: 'Déjà un compte ?',
    register_link: "S'inscrire",
    login_link: 'Se connecter',
    streamer_login: 'Connexion Streamer',
    // Social login
    social_or: 'ou continuer avec',
    social_google: 'Continuer avec Google',
    social_twitch: 'Continuer avec Twitch',
    // 2FA
    two_factor_title: 'Authentification à deux facteurs',
    two_factor_subtitle: "Entrez le code à 6 chiffres de votre application d'authentification.",
    two_factor_code_label: "Code d'authentification",
    two_factor_code_placeholder: '000000',
    two_factor_verify_button: 'Vérifier',
    two_factor_back: 'Retour à la connexion',
    // OAuth callback
    oauth_completing: 'Connexion en cours…',
    oauth_error_title: "Erreur d'authentification",
    oauth_error_subtitle: 'Une erreur est survenue lors de la connexion.',
    oauth_back_to_login: 'Retour à la connexion',
    oauth_error_denied: "Vous avez refusé l'accès.",
    oauth_error_failed: 'Connexion échouée. Veuillez réessayer.',
    oauth_error_unknown: 'Une erreur inconnue est survenue.',
    oauth_error_no_account: "Aucun compte trouvé. Veuillez d'abord créer un compte.",
    oauth_error_account_pending: "Votre compte est en attente d'activation par un administrateur.",
    recaptcha_notice_prefix: 'Ce site est protégé par reCAPTCHA et les',
    recaptcha_privacy: 'Politique de confidentialité',
    recaptcha_and: 'et les',
    recaptcha_terms: "Conditions d'utilisation",
    recaptcha_notice_suffix: "de Google s'appliquent.",
    register_pending_title: 'Inscription en attente de validation',
    register_pending_body:
      'Votre compte a bien été créé. Un administrateur doit le valider avant que vous puissiez vous connecter.',
  },
  common: {
    loading: 'Chargement...',
    error: 'Une erreur est survenue.',
    back: 'Retour',
    by: 'par',
    on: 'le',
    investigation: 'Enquête',
    slide: 'Diapositive {{number}}',
    refreshing: 'Actualisation...',
    cancel: 'Annuler',
    created_at: 'Créée le :',
    page_prev: 'Précédent',
    page_next: 'Suivant',
    page_info: 'Page {{page}} / {{total}}',
    notes_edit: 'Modifier',
    notes_add: 'Ajouter une note',
    delete: 'Supprimer',
    submitted_by: 'Soumise par',
    image_enlarge: "Agrandir l'image",
    image_enlarge_named: "Agrandir l'image : {{alt}}",
    image_preview: "Aperçu de l'image",
    image_close: "Fermer l'image",
    back_to_top: 'Retour en haut de page',
  },
  validation: {
    url_invalid: 'Veuillez entrer une URL valide.',
    required: 'Ce champ est obligatoire.',
    max_chars: 'Maximum {{count}} caractères.',
    comment_empty: 'Le commentaire ne peut pas être vide.',
    comment_max: 'Maximum 2000 caractères.',
    name_min: 'Le nom doit comporter au moins 2 caractères.',
    name_max: 'Le nom doit comporter au maximum 250 caractères.',
    desc_max: 'La description doit comporter au maximum 20 000 caractères.',
    id_min: "L'identifiant doit comporter au moins 2 caractères.",
    id_max: "L'identifiant doit comporter au maximum 200 caractères.",
    image_url: 'Doit être une URL valide.',
    username_min: 'Minimum 3 caractères.',
    username_max: 'Maximum 30 caractères.',
    email_invalid: 'Adresse email invalide.',
    password_min: 'Minimum 8 caractères.',
    description_required: 'La description est obligatoire.',
    account_pending: 'Votre compte est en attente de validation par un administrateur.',
  },
  editor: {
    bold: 'Gras',
    italic: 'Italique',
    strike: 'Barré',
    underline: 'Souligné',
    heading2: 'Titre H2',
    heading3: 'Titre H3',
    bullet_list: 'Liste à puces',
    ordered_list: 'Liste numérotée',
    quote: 'Citation',
    code: 'Code',
    insert_image: 'Insérer une image',
    uploading: 'Envoi en cours…',
    image_too_large: "L'image dépasse la taille maximale autorisée (30 Mo).",
    image_invalid_type: 'Format de fichier non pris en charge (JPG, PNG, WebP, GIF uniquement).',
    upload_failed: "Échec de l'envoi de l'image. Veuillez réessayer.",
    image_resize_hint: "Une fois insérée, glissez un coin de l'image pour la redimensionner.",
    save: 'Enregistrer',
    cancel: 'Annuler',
    no_notes: 'Aucune note pour le moment.',
  },
  footer: {
    tagline: 'Initiative citoyenne et collaborative de lutte contre la désinformation.',
    rights: '© {{year}} Balivernologie. Tous droits réservés.',
    rights_year: '© {{year}} Balivernologie.',
    rights_reserved: 'Tous droits réservés.',
    social_networks: 'Réseaux sociaux',
    legal: {
      title: 'Mentions',
      mentions_legales: 'Mentions légales',
      confidentialite: 'Politique de confidentialité',
      cookies: 'Cookies',
      manage_cookies: 'Gérer mes préférences de cookies',
    },
  },
  admin: {
    login_subtitle: 'Gestion des enquêtes',
    login_card_desc: 'Connectez-vous pour gérer vos enquêtes et consulter les pistes',
    login_note: 'Nouveau sur {{appName}} ? Application de démonstration pour les streamers Twitch.',
    login_welcome: 'Bon retour',
    login_twitch_button: 'Se connecter avec Twitch',
    login_or: 'ou',
    login_terms:
      "En vous connectant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité.",
    login_2fa_redirect:
      'Votre compte utilise la double authentification. Veuillez finaliser la connexion depuis la page de connexion publique.',
    settings_subtitle: 'Configurez votre espace {{appName}}',

    // Header / Sidebar
    header_subtitle: 'Gestion des enquêtes',
    header_search_placeholder: 'Rechercher des pistes… (Entrée)',
    sidebar_admin: 'Admin',
    nav_dashboard: 'Tableau de bord',
    nav_categories: 'Catégories',
    nav_investigations: 'Enquêtes',
    nav_comments: 'Commentaires',
    comments_col_investigation: 'Enquête',
    comments_col_total: 'Commentaires',
    comments_col_pending: 'En attente',
    comments_moderate_button: 'Modérer',
    comments_list_empty: 'Aucun commentaire pour le moment.',
    comments_moderation_title: 'Modération des commentaires',
    comments_moderation_empty: 'Aucun commentaire en attente de validation.',
    comments_validate: 'Valider',
    comments_reject: 'Rejeter',
    comments_validated_toast: 'Commentaire validé',
    comments_rejected_toast: 'Commentaire rejeté',
    nav_leads: 'Pistes',
    nav_live: 'Live',
    nav_import_export: 'Import / Export',
    nav_translations: 'Traductions',
    nav_settings: 'Paramètres',
    nav_profile: 'Profil',
    // Page profil
    profile_title: 'Mon Profil',
    profile_subtitle: 'Gérer les informations de votre compte',
    profile_info_title: 'Informations du compte',
    profile_info_desc: 'Consultez et modifiez vos informations personnelles',
    profile_username: "Nom d'utilisateur",
    profile_role: 'Rôle',
    profile_display_name: "Nom d'affichage",
    profile_display_name_placeholder: 'Votre nom tel que vous voulez être connu',
    profile_first_name: 'Prénom',
    profile_first_name_placeholder: 'Votre prénom',
    profile_last_name: 'Nom de famille',
    profile_last_name_placeholder: 'Votre nom de famille',
    profile_email: 'E-Mail',
    profile_email_placeholder: 'Votre adresse e-mail',
    profile_email_conflict: 'Cette adresse e-mail est déjà utilisée',
    profile_avatar_label: 'Photo de profil',
    profile_bio_label: 'Bio',
    profile_bio_placeholder: 'Présentez-vous en quelques mots… (140 caractères max)',
    profile_save: 'Enregistrer',
    profile_save_success: 'Profil mis à jour avec succès',
    profile_save_error: 'Impossible de mettre à jour le profil',
    // Gestion 2FA
    profile_2fa_title: 'Double authentification',
    profile_2fa_desc:
      'Ajoutez une couche de sécurité supplémentaire à votre compte avec un mot de passe à usage unique.',
    profile_2fa_status_enabled: 'Activée',
    profile_2fa_status_disabled: 'Désactivée',
    profile_2fa_enable_btn: 'Activer la 2FA',
    profile_2fa_disable_btn: 'Désactiver la 2FA',
    profile_2fa_setup_instruction:
      'Scannez ce QR code avec votre application d’authentification (Google Authenticator, Authy, 1Password…)',
    profile_2fa_manual_entry: 'Ou saisissez ce code manuellement :',
    profile_2fa_confirm_label: 'Entrez le code à 6 chiffres pour confirmer',
    profile_2fa_confirm_placeholder: '000000',
    profile_2fa_confirm_btn: 'Confirmer et activer',
    profile_2fa_disable_instruction:
      'Entrez le code à 6 chiffres de votre application pour désactiver la 2FA.',
    profile_2fa_disable_confirm_btn: 'Confirmer et désactiver',
    profile_2fa_cancel: 'Annuler',
    profile_2fa_enabled_success: 'La double authentification a été activée sur votre compte.',
    profile_2fa_disabled_success: 'La double authentification a été désactivée.',
    profile_2fa_error: 'Code invalide. Veuillez réessayer.',
    // Gestion de l'équipe
    team_title: "Équipe d'enquête",
    team_subtitle: 'Gérer les enquêteurs de cette enquête',
    team_empty: "Aucun enquêteur pour l'instant. Ajoutez des membres pour collaborer.",
    team_add: 'Ajouter un enquêteur',
    team_remove: 'Retirer',
    team_remove_confirm: "Retirer cet enquêteur de l'équipe ?",
    team_removed: 'Enquêteur retiré',
    team_added: 'Enquêteur ajouté',
    team_add_dialog_title: 'Ajouter un enquêteur',
    team_search_placeholder: "Rechercher par nom d'utilisateur...",
    team_no_results: 'Aucun utilisateur trouvé',
    // Suggestions
    nav_suggestions: 'Suggestions',
    suggestions_page_title: 'Enquêtes suggérées',
    suggestions_page_subtitle:
      'Examinez les suggestions de la communauté et transformez-les en enquêtes',
    suggestions_empty_title: 'Aucune suggestion pour le moment',
    suggestions_empty_body:
      'Les utilisateurs peuvent suggérer des enquêtes depuis la page publique des enquêtes.',
    suggestions_col_title: 'Titre',
    suggestions_col_description: 'Description',
    suggestions_col_votes: 'Votes',
    suggestions_col_by: 'Suggéré par',
    suggestions_col_date: 'Date',
    suggestions_approve: 'Approuver',
    suggestions_delete: 'Supprimer',
    suggestions_delete_confirm: 'Supprimer cette suggestion ? Cette action est irréversible.',
    suggestions_deleted: 'Suggestion supprimée',
    suggestions_delete_failed: 'Impossible de supprimer la suggestion',
    suggestions_approve_dialog_title: 'Approuver la suggestion',
    suggestions_approve_dialog_subtitle:
      'Remplissez les détails manquants pour créer une enquête à partir de cette suggestion.',
    suggestions_approved: 'Enquête créée avec succès !',
    suggestions_approve_failed: "Impossible de créer l'enquête",
    suggestions_badge_votes: '{{count}} votes',
    suggestions_no_description: 'Aucune description',
    // Gestion des investigateurs
    nav_investigators: 'Investigateurs',
    investigators_page_title: 'Gestion des investigateurs',
    investigators_page_subtitle:
      'Gérez les comptes utilisateurs et validez les nouvelles inscriptions',
    comments_subtitle: 'Modérer les commentaires publiés sur les enquêtes.',
    import_export_subtitle: 'Importer et exporter les enquêtes, pistes et faits.',
    investigators_tab_pending: 'En attente ({{count}})',
    investigators_tab_all: 'Tous',
    investigators_col_user: 'Utilisateur',
    investigators_col_email: 'Email',
    investigators_col_role: 'Rôle',
    investigators_col_status: 'Statut',
    investigators_col_date: 'Inscription',
    investigators_col_actions: 'Actions',
    investigators_enable: 'Activer',
    investigators_disable: 'Désactiver',
    investigators_enabled: 'Actif',
    investigators_disabled: 'En attente',
    investigators_enabled_toast: 'Compte activé',
    investigators_disabled_toast: 'Compte désactivé',
    investigators_delete_confirm: 'Supprimer ce compte ? Cette action est irréversible.',
    investigators_deleted: 'Utilisateur supprimé',
    investigators_delete_failed: "Impossible de supprimer l'utilisateur",
    investigators_role_user: 'utilisateur',
    investigators_role_admin: 'admin',
    investigators_role_moderator: 'modérateur',
    investigators_role_updated: 'Rôle mis à jour',
    investigators_empty: 'Aucun utilisateur trouvé',
    investigators_pending_empty: 'Aucun compte en attente de validation',
    logout: 'Se déconnecter',
    login: 'Se connecter',
    header_title_dashboard: 'Tableau de bord',
    header_title_investigations: 'Enquêtes',
    header_title_new_investigation: 'Nouvelle enquête',
    header_title_edit_investigation: "Modifier l'enquête",
    header_title_investigation_leads: "Pistes de l'enquête",
    header_title_lead_detail: 'Détail de la piste',
    // Dashboard
    dash_stat_inv_title: 'Total enquêtes',
    dash_stat_inv_desc: 'Créer et gérer les enquêtes pour votre stream',
    dash_stat_leads_title: 'Total pistes',
    dash_stat_leads_desc: 'Toutes les pistes soumises par les spectateurs',
    dash_stat_activity_title: 'Activité récente',
    dash_stat_activity_desc: 'Nouvelles pistes dans la dernière heure',
    dash_stat_submitters_title: 'Meilleurs contributeurs',
    dash_stat_submitters_desc: 'Spectateurs uniques ayant soumis des pistes',
    dash_your_investigations: 'Vos enquêtes',
    dash_add_investigation: '+ Ajouter une enquête',
    dash_no_investigations:
      'Aucune enquête créée. Créez la première pour commencer à recevoir des pistes !',
    dash_leads_by_investigation: 'Pistes par enquête',
    dash_no_leads:
      'Aucune piste soumise. Les spectateurs peuvent en soumettre avec la commande !lead.',
    dash_quick_create_title: 'Créer une enquête',
    dash_quick_create_desc: 'Ajouter une nouvelle enquête pour recevoir des pistes',
    dash_quick_leads_title: 'Voir toutes les pistes',
    dash_quick_leads_desc: 'Voir toutes les pistes soumises en un seul endroit',
    dash_quick_live_title: 'Vue streamer',
    dash_quick_live_desc: 'Vue en temps réel des pistes au fur et à mesure',
    // Investigations list
    inv_toggle_activate: 'Passer en cours',
    inv_toggle_deactivate: 'Passer en terminée',
    inv_activated: 'Enquête passée en cours',
    inv_deactivated: 'Enquête passée en terminée',
    inv_toggle_failed: 'Impossible de changer le statut',
    inv_status_active: 'En cours',
    inv_status_inactive: 'Terminée',
    inv_status_pending: 'En attente',
    inv_filter_status_all: 'Tous les états',
    inv_filter_status_pending: 'En attente',
    inv_filter_status_active: 'En cours',
    inv_filter_status_inactive: 'Terminées',
    inv_set_status: "Changer l'état",
    inv_conclusion_label: 'Conclusion',
    inv_conclusion_none: 'En cours',
    inv_conclusion_true: 'Vrai',
    inv_conclusion_false: 'Faux',
    inv_conclusion_fallacious: 'Fallacieux',
    inv_conclusion_completed: 'Terminée',
    inv_conclusion_success: 'Conclusion enregistrée',
    inv_conclusion_failed: "Impossible d'enregistrer la conclusion : {{error}}",
    inv_conclusion_inactive_note: "La définition d'une conclusion marque l'enquête comme terminée.",
    lead_conclusion_label: 'Conclusion de la piste',
    lead_conclusion_none: 'En cours',
    lead_conclusion_success: 'Conclusion de la piste enregistrée',
    lead_conclusion_failed: "Impossible d'enregistrer la conclusion de la piste : {{error}}",
    inv_delete_confirm:
      'Êtes-vous sûr de vouloir supprimer "{{name}}" ? Toutes les pistes associées seront également supprimées.',
    inv_deleted: 'Enquête "{{name}}" supprimée avec succès',
    inv_delete_failed: "Impossible de supprimer l'enquête : {{error}}",
    inv_page_title: 'Enquêtes',
    inv_page_subtitle: 'Gestion des enquêtes',
    inv_empty_title: 'Aucune enquête créée',
    inv_empty_body: 'Créez votre première enquête pour commencer à recevoir des pistes',
    inv_empty_button: 'Créer votre première enquête',
    inv_card_created: 'Créée le :',
    inv_view_leads: 'Voir les pistes',
    inv_leads_page_title: 'Pistes',
    inv_leads_back: 'Retour aux enquêtes',
    preview_article: 'Prévisualiser',
    inv_leads_add: 'Ajouter une piste',
    inv_leads_empty_title: 'Aucune piste',
    inv_leads_empty_body: 'Ajoutez la première piste pour cette enquête.',
    inv_lead_detail_back: 'Retour aux pistes',
    pagination_info: 'Page {{page}} sur {{total}}',
    // Forms (create / edit)
    form_cancel: 'Annuler',
    form_create_title: 'Créer une nouvelle enquête',
    form_create_subtitle:
      'Créer une nouvelle enquête pour que les spectateurs soumettent des pistes',
    form_create_submit: 'Créer une enquête',
    form_create_success: 'Enquête "{{name}}" créée avec succès',
    form_create_error: "Impossible de créer l'enquête : {{error}}",
    form_edit_title: "Modifier l'enquête",
    form_edit_subtitle: 'Modifier les détails de cette enquête',
    form_edit_submit: "Mettre à jour l'enquête",
    form_edit_success: 'Enquête "{{name}}" mise à jour avec succès',
    form_edit_error: "Impossible de mettre à jour l'enquête : {{error}}",
    form_name_label: "Nom de l'enquête *",
    form_name_placeholder: 'Ex. : La Grande Arnaque Climatique',
    form_name_desc: 'Un nom unique pour cette enquête (visible par les spectateurs)',
    form_desc_label: 'Description',
    form_desc_placeholder: 'Ex. : Astuces et conseils pour le développement React',
    form_desc_helper: "Description facultative pour aider les spectateurs à comprendre l'enquête",
    form_id_label: "Identifiant de l'enquête *",
    form_id_placeholder: 'Ex. : grande-arnaque-climatique',
    form_id_desc: 'Un identifiant unique pour cette enquête (utilisé dans les commandes !lead)',
    form_author_placeholder: 'Ex. : Le Monde, BFMTV…',
    form_category_label: 'Catégorie',
    form_category_placeholder: 'Ex. : Politique, Médias, Science…',
    form_category_desc: 'Catégorie affichée sur la page publique des enquêtes',
    form_image_label: 'Image de couverture',
    form_image_desc: 'Télécharger un fichier ou coller une URL externe (facultatif)',
    form_live_section: 'Vidéo associée',
    form_live_date_label: 'Date et heure du live (facultatif)',
    form_live_date_desc: 'Date et heure du live. Laisser vide pour une simple vidéo.',
    form_live_twitch_label: 'Lien Twitch',
    form_live_twitch_desc: 'URL du stream Twitch (facultatif).',
    form_live_youtube_label: 'Lien YouTube',
    form_live_youtube_desc: "URL du live, du replay ou d'une simple vidéo YouTube.",
    form_author_label: 'Auteur',
    form_author_desc: "L'utilisateur crédité comme auteur de cette enquête",
    form_author_desc_lead: "L'utilisateur crédité comme auteur de cette piste",
    form_author_desc_fact: "L'utilisateur crédité comme auteur de ce fait",
    form_author_search_placeholder: 'Rechercher par nom d’utilisateur ou prénom…',
    form_author_current: 'Auteur actuel :',
    form_author_clear: 'Supprimer l’auteur',
    form_author_none: 'Aucun auteur assigné',
    form_investigation_search_placeholder: 'Rechercher une enquête…',
    form_investigation_clear: "Retirer l'enquête liée",
    form_investigation_none: 'Aucune enquête liée',
    form_investigation_no_results: 'Aucune enquête trouvée',
    // Leads list
    leads_title: 'Toutes les pistes',
    leads_subtitle: 'Parcourir et gérer toutes les pistes soumises',
    leads_search_placeholder: 'Rechercher des pistes...',
    leads_all_topics: 'Toutes les enquêtes',
    leads_filter_submitter: 'Filtrer par auteur...',
    leads_found: '{{count}} piste(s) trouvée(s)',
    leads_empty_title: 'Aucune piste trouvée',
    leads_empty_body: "Essayez d'ajuster vos filtres ou revenez plus tard",
    leads_delete_confirm: 'Êtes-vous sûr de vouloir supprimer cette piste ?',
    leads_deleted: 'Piste supprimée avec succès',
    leads_delete_failed: 'Impossible de supprimer la piste : {{error}}',
    leads_edit_dialog_title: 'Modifier la piste',
    leads_edit_title_label: 'Titre',
    leads_edit_description_label: 'Description',
    leads_edit_image_label: 'Image',
    leads_edit_submit: 'Enregistrer les modifications',
    leads_edit_success: 'Piste modifiée avec succès',
    leads_edit_failed: 'Impossible de modifier la piste : {{error}}',
    // Leads by investigation
    leads_by_inv_not_found: 'Enquête introuvable',
    leads_by_inv_not_found_body: "L'enquête que vous recherchez n'existe pas.",
    leads_by_inv_view_all: 'Voir toutes les enquêtes',
    leads_by_inv_id: 'ID enquête :',
    leads_by_inv_count: '{{count}} piste(s)',
    leads_by_inv_sorted: 'Trié par date (plus ancien en premier)',
    leads_by_inv_empty_title: 'Aucune piste pour cette enquête',
    leads_by_inv_empty_body: 'Les spectateurs peuvent soumettre des pistes avec la commande !lead',
    // LeadGroupList
    lead_group_empty: 'Aucune piste. Les spectateurs peuvent en soumettre avec la commande !lead.',
    lead_group_more: '+{{count}} pistes supplémentaires',
    lead_group_count: '{{count}} piste(s)',
    // ImageField
    image_upload_aria: 'Télécharger une image de couverture',
    image_click_replace: 'Cliquer pour remplacer',
    image_drop_prompt: 'Cliquer ou glisser-déposer pour télécharger',
    image_file_hint: 'JPG, PNG, WebP, GIF · 30 Mo max',
    image_remove: "Supprimer l'image",
    image_url_separator: 'ou saisir une URL',
    // Live view
    live_title: 'Vue streamer',
    live_subtitle: 'Gestion des lives',
    live_refresh: 'Actualiser',
    live_auto_on: 'Actualisation auto : activée',
    live_auto_off: 'Actualisation auto : désactivée',
    live_filter_label: 'Filtrer par enquête :',
    live_all_investigations: 'Toutes les enquêtes ({{count}} pistes)',
    live_topic_leads: '{{count}} piste(s)',
    live_oldest_first: 'Plus ancien en premier',
    live_newest_first: 'Plus récent en premier',
    live_stat_total_leads: 'Total pistes',
    live_stat_active: 'Enquêtes actives',
    live_stat_submitters: 'Contributeurs uniques',
    live_tab_by_investigation: 'Par enquête',
    live_tab_all: 'Toutes les pistes',
    live_empty_title: 'Aucune piste',
    live_empty_body: 'Les spectateurs peuvent soumettre des pistes avec la commande !lead',
    live_no_ongoing_title: 'Aucune enquête en cours',
    live_no_ongoing_body:
      'Marquez des enquêtes comme en cours dans la page de gestion pour les voir ici.',
    live_all_leads_title: 'Toutes les pistes ({{count}})',
    live_no_leads: 'Aucune piste soumise',
    live_refreshed: 'Actualisé avec succès',
    live_refresh_failed: 'Actualisation échouée',
    // Active investigation / lead
    live_bot_panel_title: 'Bot Twitch',
    live_bot_panel_show: 'Afficher',
    live_bot_panel_hide: 'Masquer',
    live_active_section_title: 'Contexte actif',
    live_active_investigation_label: 'Enquête active',
    live_no_active_investigation:
      'Aucune enquête active. Cliquez sur "Rendre active" sur une enquête ci-dessous.',
    live_active_lead_label: 'Piste active',
    live_no_active_lead: 'Aucune piste pour cette enquête.',
    live_active_fact_label: 'Fait actif',
    live_no_active_fact: 'Aucun fait actif.',
    live_set_active_investigation: 'Rendre active',
    live_set_active_lead: 'Rendre piste active',
    live_active_badge: 'Active',
    live_active_lead_badge: 'Piste active',
    live_active_fact_badge: 'Fait actif',
    live_original_source_badge: 'Original',
    live_set_active_fact: 'Définir comme fait actif',
    live_unset_active_fact: 'Retirer le fait actif',
    live_active_fact_set: 'Fait actif défini',
    live_active_fact_cleared: 'Fait actif retiré',
    live_active_fact_failed: 'Impossible de modifier le fait actif',
    live_commands_reference: 'Commandes de chat',
    // Settings
    settings_title: 'Paramètres',
    settings_profile_title: 'Profil',
    settings_profile_desc: 'Gérer vos paramètres de profil et préférences',
    settings_profile_placeholder:
      'Les paramètres de profil seront disponibles dans une prochaine mise à jour.',
    settings_twitch_title: 'Connexion du bot Twitch',
    settings_twitch_desc:
      'Authentifiez le bot de chat via Twitch OAuth. Les tokens sont stockés en base et actualisés automatiquement — plus de commandes manuelles.',
    settings_commands_title: 'Commandes de chat disponibles',
    settings_notif_title: 'Notifications',
    settings_notif_desc: 'Configurer comment vous recevez les notifications',
    settings_notif_placeholder:
      'Les paramètres de notification seront disponibles dans une prochaine mise à jour.',
    settings_tech_title: 'Technologies',
    // Site identity (white-label)
    settings_site_title: 'Identité du site',
    settings_site_card_desc: 'Personnalisez le nom, la description et le thème de votre site',
    settings_site_name_label: 'Nom du site',
    settings_site_name_placeholder: 'Ex : Mon Site Enquêtes',
    settings_site_description_label: 'Description',
    settings_site_description_placeholder: 'Une courte description de votre site',
    settings_theme_label: 'Thème (utilisateurs connectés)',
    settings_theme_desc:
      "Apparence appliquée pour vous une fois connecté, à la fois dans l'administration et sur les pages publiques telles que vous les voyez.",
    settings_public_theme_label: 'Thème public (visiteurs non connectés)',
    settings_public_theme_desc:
      'Apparence vue par les visiteurs anonymes sur les pages publiques du site.',
    settings_site_save_button: 'Sauvegarder',
    settings_site_saved: 'Paramètres du site sauvegardés',
    settings_homepage_layout_label: "Mise en page de l'accueil",
    settings_homepage_layout_classic: 'Classique',
    settings_homepage_layout_news: 'Une de journal',
    // Social networks
    settings_social_title: 'Réseaux sociaux',
    settings_social_card_desc:
      'Configurez les liens vers vos réseaux sociaux affichés sur la page À propos',
    settings_social_save_button: 'Sauvegarder',
    settings_social_saved: 'Réseaux sociaux sauvegardés',
    settings_social_x_label: 'X (ex-Twitter)',
    settings_social_bluesky_label: 'BlueSky',
    settings_social_facebook_label: 'Facebook',
    settings_social_instagram_label: 'Instagram',
    settings_social_tiktok_label: 'TikTok',
    settings_social_youtube_label: 'YouTube',
    settings_social_twitch_label: 'Twitch',
    settings_social_discord_label: 'Discord',
    settings_social_footer_links_title: 'Liens dans le footer',
    settings_social_footer_links_desc:
      "Sélectionnez jusqu'à 6 réseaux à afficher dans le pied de page (uniquement ceux avec une URL configurée).",
    // Breaking news banner
    settings_breaking_title: 'Bandeau info',
    settings_breaking_card_desc: "Configurez le bandeau d'info affiché sur la une",
    settings_breaking_active_label: 'Actif',
    settings_breaking_message_label: 'Message',
    settings_breaking_investigation_label: 'Enquête liée (optionnel)',
    settings_breaking_link_mode_label: 'Lien du bandeau',
    settings_breaking_link_mode_none: 'Aucun',
    settings_breaking_link_mode_investigation: 'Enquête liée',
    settings_breaking_link_mode_link: 'Lien personnalisé',
    settings_breaking_link_label: 'Lien personnalisé',
    settings_breaking_save_button: 'Sauvegarder',
    settings_breaking_saved: 'Bandeau info sauvegardé',
    // Language selector
    settings_lang_section_title: 'Langue pour les paramètres',
    settings_lang_section_desc: 'Définissez les paramètres du site pour chaque langue disponible.',
    twitch_checking: 'Vérification de la connexion…',
    twitch_connected_as: 'Connecté en tant que',
    twitch_expires_in: 'expire dans {{minutes}} min',
    twitch_expired: 'Token expiré pour @{{username}} — nouvelle authentification requise',
    twitch_not_connected: 'Bot non connecté',
    twitch_disconnect: 'Déconnecter le bot',
    twitch_reauthenticate: 'Ré-authentifier le bot',
    twitch_connect: 'Connecter le bot avec Twitch',
    twitch_language_label: 'Langue du bot',
    twitch_language_en: '🇬🇧 Anglais',
    twitch_language_fr: '🇫🇷 Français',
    twitch_language_desc:
      'Tous les messages du bot dans le chat Twitch (accueil, commandes, annonces) utiliseront cette langue.',
    twitch_language_saved: 'Langue sauvegardée.',
    bot_send_welcome: 'Envoyer le message de bienvenue',
    bot_send_welcome_desc:
      "Envoie l'introduction du bot et la liste des commandes dans tous les chats connectés.",
    bot_welcome_sent: 'Message de bienvenue envoyé.',
    twitch_connected_toast: 'Bot @{{username}} connecté avec succès !',
    twitch_connected_generic: 'Bot Twitch connecté avec succès !',
    twitch_denied: "L'autorisation Twitch a été refusée.",
    youtube_checking: 'Vérification du statut YouTube...',
    youtube_connected_as: 'Connecté en tant que',
    youtube_expires_in: 'Expire dans {{minutes}} min',
    youtube_expired: 'Token expiré pour {{username}}',
    youtube_not_connected: 'Bot YouTube non connecté',
    youtube_disconnect: 'Déconnecter le bot',
    youtube_connect: 'Connecter le bot YouTube',
    youtube_reauthenticate: 'Reconnecter le bot YouTube',
    // Suppression de compte (Zone de danger)
    profile_delete_title: 'Supprimer le compte',
    profile_delete_desc: 'Supprimez définitivement votre compte et toutes les données associées.',
    profile_delete_warning:
      'Cela supprimera définitivement votre profil, vos commentaires et vos votes de suggestions. Vos enquêtes, pistes et suggestions seront conservées et réattribuées au streamer. Cette action est irréversible.',
    profile_delete_btn: 'Supprimer mon compte…',
    profile_delete_confirm_label: "Pour confirmer, saisissez votre nom d'utilisateur :",
    profile_delete_confirm_placeholder: "Votre nom d'utilisateur",
    profile_delete_confirm_btn: 'Oui, supprimer définitivement',
    profile_delete_cancel: 'Annuler',
    profile_delete_success: 'Votre compte a été définitivement supprimé.',
    profile_delete_error: 'Échec de la suppression du compte. Veuillez réessayer.',
  },
  about: {
    title: 'À propos',
    description:
      "{{appName}} est une plateforme d'enquêtes citoyenne et collaborative de lutte contre la désinformation.",
    follow_us: 'Suivez-nous sur',
  },
  read_mode: {
    print: 'Imprimer',
    share: 'Partager',
    share_facebook: 'Partager sur Facebook',
    share_x: 'Partager sur X',
    share_bluesky: 'Partager sur Bluesky',
    toc_title: 'Dans cette enquête',
    source_label: 'Source originale',
    notes_label: 'Analyses et synthèse',
    facts_title: 'Faits',
    no_facts: 'Aucun fait pour cette piste pour le moment.',
    by: 'Par',
    comments_link: 'Commentaires',
    reading_time_one: '{{count}} minute',
    reading_time_other: '{{count}} minutes',
    preview_banner: 'Vous visualisez un aperçu incluant du contenu non publié.',
    preview_banner_public:
      'Vous visualisez la version publique incluant uniquement le contenu publié.',
    preview_banner_view_public: 'Voir la version publiée',
    preview_banner_view_preview: "Revenir à l'aperçu",
    listen: {
      region_label: "Lecteur audio de l'article",
      cta: "Écouter l'article",
      duration_one: '{{count}} min',
      duration_other: '{{count}} min',
      play_label: "Écouter l'article, {{duration}}",
      pause: 'Mettre en pause',
      resume: 'Reprendre la lecture',
      replay: 'Réécouter',
      stop: 'Arrêter la lecture',
      seek_label: 'Position de lecture',
      position_text: '{{elapsed}} sur {{total}}',
      speed_label: 'Vitesse de lecture : {{rate}}×',
      more_options: 'Options de lecture',
      voice_label: 'Voix',
      voice_auto: 'Automatique',
      voice_quality_high: 'Naturelle',
      voice_low_quality_hint: 'Voix système de qualité limitée',
      now_listening: 'En écoute',
      status_playing: 'Lecture en cours',
      status_paused: 'Lecture en pause',
      status_ended: 'Lecture terminée',
      error: 'Lecture interrompue',
      retry: 'Réessayer',
      minutes_seconds: '{{m}} min {{s}} s',
      preparing: 'Préparation de la voix…',
      preparing_percent: 'Téléchargement de la voix… {{percent}} %',
      consent_title: 'Voix du site',
      consent_body:
        'Voix du site : téléchargement de ~{{size}} Mo par langue, une seule fois. Les mêmes voix sur tous les appareils.',
      consent_download: 'Télécharger',
      consent_device: "Utiliser la voix de l'appareil",
      engine_label: 'Moteur vocal',
      engine_site: 'Voix du site',
      engine_device: "Voix de l'appareil",
      engine_device_unavailable: "Aucune voix de l'appareil pour cette langue",
      active_voice: 'Voix active : {{name}}',
      active_voice_device: "Voix active : voix de l'appareil",
      credits_link: 'Crédits audio',
      fallback_notice: "La voix du site n'a pas pu être chargée : voix de l'appareil utilisée.",
    },
  },
  article_comments: {
    title: 'Commentaires',
    no_comments: 'Aucun commentaire. Soyez le premier !',
    placeholder: 'Partagez vos réflexions...',
    submit: 'Publier',
    login_to_comment: 'Connectez-vous pour commenter',
    login_to_reply: 'Connectez-vous pour répondre',
    reply: 'Répondre',
    reply_placeholder: 'Écrivez votre réponse...',
    reply_submit: 'Publier la réponse',
    cancel_reply: 'Annuler',
    pending: 'En attente de validation',
    approve: 'Approuver',
    edit: 'Modifier',
    delete: 'Supprimer',
    edit_dialog_title: 'Modifier le commentaire',
    edit_submit: 'Enregistrer',
    approved_toast: 'Commentaire approuvé',
    deleted_toast: 'Commentaire supprimé',
    updated_toast: 'Commentaire mis à jour',
    delete_confirm: 'Supprimer ce commentaire ?',
    my_pending_note: 'Votre commentaire est en attente de validation',
    published_toast: 'Commentaire publié !',
    reply_published_toast: 'Réponse publiée !',
    moderate_validate: 'Valider',
    moderate_reject: 'Rejeter',
  },
  pwa_install: {
    title: "Installer Balivernologie sur votre écran d'accueil",
    description:
      "Ajoutez l'application à votre écran d'accueil pour y accéder en un geste, en plein écran et même hors connexion.",
    ios_step_share: 'Appuyez sur Partager, dans la barre en bas du navigateur.',
    ipados_step_share: 'Appuyez sur Partager, dans la barre en haut du navigateur.',
    ios_step_more: 'Puis sur « Voir plus » pour dérouler toute la liste.',
    ios_step_add: "Puis « Sur l'écran d'accueil », et confirmez avec « Ajouter ».",
    android_step_menu: 'Ouvrez le menu du navigateur, en haut à droite.',
    android_step_add: "Choisissez « Ajouter à l'écran d'accueil », puis confirmez.",
    install_action: "Installer l'application",
    dismiss: 'Non merci',
    close: "Fermer l'invitation",
  },
  audio_credits: {
    page_title: 'Crédits audio',
    intro:
      "La fonction « Écouter l'article » utilise des voix synthétiques téléchargées une seule fois dans votre navigateur, avec votre accord, puis exécutées localement : aucun texte n'est envoyé à un serveur.",
    voices_title: 'Voix',
    voice_license: 'Licence',
    voice_credit: 'Crédit',
    voice_source:
      'Les modèles de voix proviennent du dépôt Hugging Face rhasspy/piper-voices, à la révision {{revision}}.',
    piper_title: 'Piper',
    piper_body:
      "La synthèse vocale repose sur Piper (rhasspy/piper, licence MIT). L'exécution dans le navigateur utilise piper-wasm de Diffusion Studio (licence MIT) et s'inspire de piper-tts-web de Mintplex Labs (licence MIT).",
    espeak_title: 'eSpeak NG',
    espeak_body:
      "La phonétisation du texte utilise eSpeak NG, distribué sous licence GNU GPL version 3 ou ultérieure. Ses sources sont disponibles à l'adresse :",
    onnx_title: 'ONNX Runtime Web',
    onnx_body:
      'Les modèles sont exécutés par ONNX Runtime Web (Microsoft, licence MIT), compilé en WebAssembly.',
  },
  cookies: {
    banner_title: 'Nous respectons votre vie privée',
    banner_description:
      'Nous utilisons un cookie strictement nécessaire pour mémoriser votre choix de consentement, et — uniquement avec votre accord — une catégorie pour les médias tiers intégrés.',
    banner_privacy_link: 'En savoir plus dans notre politique de confidentialité',
    accept_all: 'Tout accepter',
    refuse_all: 'Tout refuser',
    customize: 'Personnaliser',
    preferences_title: 'Préférences de cookies',
    preferences_description:
      'Choisissez les catégories de cookies et de stockage local que vous autorisez. Vous pouvez modifier ce choix à tout moment depuis le lien « Cookies » dans le pied de page.',
    category_necessary_title: 'Strictement nécessaires',
    category_necessary_description:
      'Nécessaires pour enregistrer votre choix de consentement lui-même. Toujours actifs — ne peuvent pas être désactivés.',
    category_media_title: 'Médias tiers intégrés',
    category_media_description:
      "Permet l'affichage de contenus intégrés provenant de services tiers comme YouTube, Vimeo ou des cartes. Désactivé par défaut.",
    save_preferences: 'Enregistrer mes préférences',
    embed_blocked:
      "Ce contenu nécessite votre consentement aux médias tiers intégrés pour s'afficher.",
    embed_blocked_named:
      "Ce contenu provenant de {{service}} nécessite votre consentement aux médias tiers intégrés pour s'afficher.",
    embed_accept: 'Accepter et charger le contenu',
    page_title: 'Politique de cookies',
    page_intro:
      "Cette page explique ce qu'est un cookie, ce que nous utilisons, pourquoi, pendant combien de temps, et comment modifier votre choix à tout moment.",
    page_what_is_title: "Qu'est-ce qu'un cookie ?",
    page_what_is_body:
      "Un cookie (ou une entrée équivalente de stockage local) est une petite donnée enregistrée par votre navigateur lors de votre visite d'un site. Il peut servir à mémoriser des informations, comme vos préférences ou un choix effectué, d'une visite à l'autre.",
    page_what_we_use_title: 'Ce que nous utilisons, et pourquoi',
    page_categories_intro:
      'Nous utilisons exactement deux catégories de cookies/stockage local, pas plus :',
    page_category_necessary:
      "Strictement nécessaires — une unique entrée localStorage de premier niveau (first-party) qui enregistre le choix de consentement lui-même (quelles catégories vous avez acceptées, quand, et quelle version de cette politique). Sans elle, nous ne saurions pas que vous avez déjà répondu, et la bannière réapparaîtrait à chaque visite. Cette catégorie n'est pas désactivable, puisqu'elle est ce qui rend vos autres choix possibles.",
    page_category_media:
      "Médias tiers intégrés — réservée à de futurs contenus tiers intégrés (par ex. YouTube, Vimeo, cartes interactives) susceptibles d'être ajoutés au site. Rien de ces services ne se charge tant que vous n'avez pas donné votre accord explicite, que ce soit depuis la bannière, le panneau de préférences, ou le bouton « accepter et charger » proposé directement sur un contenu bloqué.",
    page_first_third_title: 'Premier niveau (first-party) vs. tiers (third-party)',
    page_first_third_body:
      'Le fichier de consentement lui-même est de premier niveau (stocké uniquement dans votre navigateur, uniquement pour ce site). La catégorie « médias tiers intégrés », une fois acceptée, permet à un contenu servi directement par un fournisseur extérieur (par ex. YouTube) de se charger dans la page — ce fournisseur peut alors déposer ses propres cookies, régis par sa propre politique.',
    page_duration_title: 'Combien de temps le consentement est-il valable ?',
    page_duration_body:
      "Votre choix de consentement est conservé pendant 6 mois. Passé ce délai, il expire automatiquement et la bannière est de nouveau affichée afin que vous puissiez confirmer ou modifier votre choix. Il est également réinitialisé chaque fois que cette politique de cookies change d'une manière qui nécessite de vous redemander votre accord.",
    page_change_title: 'Modifier votre choix',
    page_change_body:
      'Vous pouvez consulter ou modifier vos préférences à tout moment en cliquant sur le bouton ci-dessous, ou via le lien « Cookies » présent dans le pied de page de chaque page.',
    page_change_button: 'Gérer mes préférences de cookies',
    page_browser_title: 'Réglages du navigateur',
    page_browser_body:
      "Indépendamment de l'outil de consentement de ce site, votre navigateur vous permet de consulter, supprimer ou bloquer les cookies et le stockage local de manière générale — consultez les réglages ou l'aide de votre navigateur pour la marche à suivre exacte, celle-ci variant selon le navigateur et sa version.",
  },
  legal: {
    mentions: {
      page_title: 'Mentions légales',
      publisher_title: 'Éditeur du site',
      publisher_body:
        "Ce site est édité par Bertrand PRESLES, agissant à titre individuel et non professionnel. S'agissant d'un projet personnel et non commercial, aucun numéro SIRET/RCS, capital social ou numéro de TVA ne s'applique.",
      publisher_address_label: 'Adresse',
      publisher_address_value: '18 Bis Rue du Petit Village, 44800 Saint-Herblain, France',
      director_title: 'Directeur de la publication',
      director_body: 'Bertrand PRESLES.',
      contact_title: 'Contact',
      contact_body: 'Pour toute question relative à ce site, vous pouvez écrire à :',
      host_title: 'Hébergement',
      host_frontend_label: 'Site web (frontend) hébergé par',
      host_frontend_value: 'Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis',
      host_frontend_site: 'https://vercel.com',
      host_backend_label: 'Backend applicatif (API) hébergé par',
      host_backend_value:
        "Koyeb — service propriété de Mistral AI (SIREN 952 418 325), 15 rue des Halles, 75001 Paris, France. La société Koyeb (SIREN 850 183 948) a fait l'objet d'une transmission universelle de patrimoine au profit de Mistral AI et a été radiée du registre du commerce et des sociétés le 12 mai 2026.",
      host_backend_site: 'https://www.koyeb.com',
      host_database_label: 'Base de données hébergée par',
      host_database_value:
        'Neon — base de données PostgreSQL hébergée au Royaume-Uni (Londres), chez AWS.',
      host_database_site: 'https://neon.com',
      host_note:
        'Voir la politique de confidentialité pour le détail des transferts de données et des garanties applicables à chacun de ces sous-traitants.',
    },
    privacy: {
      page_title: 'Politique de confidentialité',
      intro_title: 'Introduction',
      intro_body:
        'Cette politique de confidentialité explique quelles données personnelles Balivernologie collecte, pourquoi, sur quelle base légale, pendant combien de temps, avec qui elles peuvent être partagées, et quels droits vous détenez sur elles, conformément au RGPD.',
      controller_title: 'Responsable du traitement',
      controller_body:
        'Le responsable du traitement est Bertrand PRESLES, exploitant ce site à titre individuel et non professionnel. Vous pouvez exercer vos droits ou poser toute question en écrivant à :',
      data_title: 'Quelles données nous collectons, et pourquoi',
      data_intro:
        "Nous ne collectons que les données que vous fournissez directement en créant un compte, en soumettant du contenu, ou en interagissant avec le site. Nous n'utilisons ni cookies analytiques ni cookies publicitaires, et nous ne collectons ni adresse IP, ni empreinte de navigateur, ni cookie de session/traçage.",
      data_account_title: 'Données de compte',
      data_account_body:
        "Lors de la création d'un compte : nom d'utilisateur, adresse email (facultative), un mot de passe haché de manière sécurisée (jamais stocké en clair — non applicable pour les comptes créés via Google ou Twitch), photo de profil, une courte biographie, votre rôle, et — si vous l'activez — les paramètres d'authentification à deux facteurs (TOTP). Si vous vous connectez via Google ou Twitch, nous stockons également l'identifiant de compte correspondant fourni par ce prestataire. Un jeton de rafraîchissement de session haché est stocké pour vous maintenir connecté, valable 7 jours.",
      data_public_activity_title: 'Contributions publiques',
      data_public_activity_body:
        "Les commentaires, pistes, faits et suggestions d'enquêtes que vous soumettez sont stockés avec votre nom d'utilisateur public afin de pouvoir être affichés et attribués sur le site. Les commentaires nécessitent un compte — nous ne collectons pas de commentaires anonymes ou invités, et nous n'enregistrons ni adresse email ni adresse IP associée à un commentaire.",
      data_uploads_title: 'Images téléversées',
      data_uploads_body:
        'Les images que vous téléversez sont stockées directement dans notre base de données, avec un identifiant du compte les ayant téléversées.',
      data_recaptcha_title: "Sécurité de l'inscription (reCAPTCHA)",
      data_recaptcha_body:
        "L'inscription à un compte est protégée par Google reCAPTCHA v3 afin de limiter les abus automatisés. Le jeton reCAPTCHA est vérifié directement auprès de Google ; nous ne stockons ni ne transmettons votre adresse IP dans le cadre de cette vérification.",
      legal_basis_title: 'Base légale des traitements',
      legal_basis_account:
        'Création de compte, authentification et affichage de vos contributions publiques : exécution du contrat que vous concluez en créant un compte (RGPD art. 6.1.b).',
      legal_basis_media:
        'Chargement de médias tiers intégrés : votre consentement explicite (RGPD art. 6.1.a), voir la politique de cookies.',
      legal_basis_recaptcha:
        "Prévention des abus lors de l'inscription via reCAPTCHA : notre intérêt légitime à protéger le service contre les abus automatisés (RGPD art. 6.1.f).",
      retention_title: 'Durées de conservation',
      retention_body:
        "À titre d'engagement de politique (la conservation n'est pas encore automatisée dans nos systèmes) : les données de compte sont conservées tant que votre compte reste actif, et vous pouvez demander leur suppression à tout moment en nous contactant — voir « Vos droits » ci-dessous. Les contributions publiques (commentaires, pistes, faits, suggestions) peuvent être conservées pour la mémoire historique d'une enquête même après suppression de votre compte, le nom d'utilisateur affiché pouvant toutefois être anonymisé sur demande.",
      recipients_title: 'Avec qui vos données sont partagées',
      recipients_intro:
        "Vos données ne sont partagées qu'avec les prestataires techniques strictement nécessaires au fonctionnement du site, agissant tous en tant que sous-traitants, ainsi qu'avec les fournisseurs d'identité que vous choisissez pour vous connecter :",
      recipients_vercel: 'Vercel Inc. (États-Unis) — héberge le frontend du site web.',
      recipients_koyeb:
        'Koyeb (service propriété de Mistral AI, 15 rue des Halles, 75001 Paris, France) — héberge le backend applicatif (serveur). De plus amples détails sur leur rôle de sous-traitant sont disponibles sur leur propre site.',
      recipients_neon:
        'Neon — héberge la base de données PostgreSQL où sont stockées les données de compte et de contenu, hébergée au Royaume-Uni (Londres) chez AWS. De plus amples détails sur leur rôle de sous-traitant sont disponibles sur leur propre site.',
      recipients_google:
        "Google — fournit l'authentification facultative « Connexion avec Google » ainsi que la vérification anti-abus reCAPTCHA.",
      recipients_twitch:
        "Twitch — fournit l'authentification facultative « Connexion avec Twitch », et exploite le bot de chat utilisé pour soumettre des pistes/faits depuis le chat du stream.",
      transfers_title: 'Transferts internationaux de données',
      transfers_body:
        "La base de données (Neon) est hébergée au Royaume-Uni (Londres) chez AWS. Le Royaume-Uni fait l'objet d'une décision d'adéquation de la Commission européenne au titre de l'article 45 du RGPD, qui reconnaît un niveau de protection des données jugé équivalent à celui de l'Union européenne — ce transfert ne nécessite donc pas de garantie supplémentaire à ce titre. Vercel (hébergement du frontend) et Google (authentification, reCAPTCHA) sont basés aux États-Unis ; pour ces transferts hors Espace économique européen, nous nous appuyons sur des garanties appropriées telles que les clauses contractuelles types et/ou le cadre de protection des données UE-États-Unis (Data Privacy Framework), selon ce qui est applicable. L'hébergeur du backend (Koyeb, service propriété de Mistral AI) est une société française établie dans l'Union européenne ; la région de traitement effective de ses serveurs n'est toutefois pas confirmée à ce jour.",
      rights_title: 'Vos droits',
      rights_intro:
        "Conformément au RGPD, vous disposez des droits suivants sur vos données personnelles, exerçables en nous écrivant à l'adresse de contact ci-dessus :",
      rights_access: "Droit d'accès à vos données personnelles.",
      rights_rectification: 'Droit de rectification des données inexactes ou incomplètes.',
      rights_erasure: "Droit à l'effacement (« droit à l'oubli »).",
      rights_restriction: 'Droit à la limitation du traitement.',
      rights_portability: 'Droit à la portabilité des données.',
      rights_objection: "Droit d'opposition au traitement fondé sur l'intérêt légitime.",
      rights_withdraw_consent:
        'Droit de retirer votre consentement à tout moment, lorsque le traitement est fondé sur le consentement.',
      complaint_title: "Droit d'introduire une réclamation",
      complaint_body:
        'Si vous estimez que vos droits en matière de protection des données ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL :',
      complaint_address: '3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07, France',
      complaint_website: 'https://www.cnil.fr',
    },
  },
  seo: {
    home_title: 'Balivernologie - Enquête et vérifications des faits pour démasquer les balivernes',
    home_description:
      "Enquêtes citoyennes de vérification des faits : nous démontons rumeurs et désinformation, source à l'appui. Enquêtes en cours, méthode ouverte et vérifiable.",
    investigations_title: 'Enquêtes',
    investigations_description:
      'Parcourez toutes les enquêtes de vérification des faits menées par la communauté Balivernologie, actives ou closes.',
    investigators_title: 'Enquêteurs',
    investigators_description:
      'Découvrez la communauté d’enquêteurs qui contribue des faits et des pistes à Balivernologie.',
    about_title: 'À propos',
    about_description:
      'Découvrez Balivernologie, une plateforme citoyenne et collaborative de lutte contre la désinformation.',
    mentions_legales_title: 'Mentions légales',
    mentions_legales_description:
      "Identité de l'éditeur et informations d'hébergement de Balivernologie.",
    confidentialite_title: 'Politique de confidentialité',
    confidentialite_description:
      'Comment Balivernologie collecte, utilise et protège vos données personnelles.',
    cookies_title: 'Politique de cookies',
    cookies_description: 'Quels cookies Balivernologie utilise et comment gérer vos préférences.',
    audio_credits_title: 'Crédits audio',
    audio_credits_description:
      "Voix, licences et logiciels libres utilisés par la fonction « Écouter l'article ».",
  },
  categories: {
    page_title: 'Catégories',
    page_subtitle: 'Gérez les catégories et leurs libellés dans chaque langue.',
    filter_placeholder: 'Filtrer par nom',
    add_button: 'Ajouter',
    add_title: 'Ajouter une catégorie',
    edit_title: 'Modifier la catégorie',
    label_fr: 'Français',
    label_en: 'Anglais',
    label_es: 'Espagnol',
    label_fr_placeholder: 'Ex. : Politique',
    label_en_placeholder: 'Ex. : Politics',
    label_es_placeholder: 'Ej. : Política',
    col_usage: 'Enquêtes',
    col_actions: 'Actions',
    empty: 'Aucune catégorie trouvée.',
    add_submit: 'Ajouter',
    save: 'Enregistrer',
    create_success: 'Catégorie ajoutée.',
    update_success: 'Catégorie modifiée.',
    delete_success: 'Catégorie supprimée.',
    delete_confirm: 'Supprimer cette catégorie ?',
    delete_in_use:
      'Cette catégorie est utilisée par {{count}} enquête(s). Choisissez une catégorie de remplacement vers laquelle les réaffecter avant de la supprimer.',
    delete_reassign_label: 'Catégorie de remplacement',
    delete_reassign_filter: 'Filtrer les catégories par nom',
    delete_reassign_empty: 'Aucune catégorie correspondante.',
    edit_aria: 'Modifier la catégorie {{name}}',
    delete_aria: 'Supprimer la catégorie {{name}}',
  },
  taxonomy: {
    search_label: 'Rechercher ou créer une catégorie',
    suggestions_label: 'Suggestions de catégories',
    suggestions_popular: 'Catégories les plus utilisées',
    suggestions_count_one: '{{count}} suggestion disponible',
    suggestions_count_other: '{{count}} suggestions disponibles',
    usage_count_one: '{{count}} enquête',
    usage_count_other: '{{count}} enquêtes',
    no_results: 'Aucune catégorie trouvée.',
    create_term: 'Créer « {{name}} »',
    creating: 'Création…',
    create_error: 'Impossible de créer la catégorie « {{name}} » : {{message}}',
    remove_term: 'Retirer la catégorie {{label}}',
    untranslated_badge_title:
      'Pas encore traduite : le nom en {{locale}} est affiché en attendant un libellé.',
    label_input_aria: 'Libellé de « {{name}} » en {{locale}}',
    labels_shared_hint:
      "Un libellé s'applique à toutes les enquêtes qui utilisent cette catégorie, pas seulement à celle-ci.",
    canonical_name_hint: "Nom d'origine de la catégorie (dans cette langue)",
    missing_source_labels_title: 'Catégories créées dans une autre langue : libellé en {{locale}}',
  },
  translations: {
    locale_fr: 'Français',
    locale_en: 'Anglais',
    locale_es: 'Espagnol',
    source_language_label: 'Rédigé en (figé une fois des traductions existantes)',
    source_language_frozen:
      'La langue source ne peut plus être changée : au moins une traduction existe déjà pour ce contenu.',
    tab_source: 'Source',
    source_field_label: 'source ({{locale}})',
    field_stale: 'source modifiée',
    field_optional: 'facultatif',
    no_categories: 'Aucune catégorie à traduire pour cette enquête.',
    badge_missing: '{{count}} manquant(s)',
    badge_stale: 'source modifiée',
    badge_complete: 'complet',
    dashboard_title: 'Tableau de bord des traductions',
    dashboard_subtitle:
      'Enquêtes publiées et leur niveau de complétude par langue — ce qui reste à traduire.',
    dashboard_col_investigation: 'Enquête',
    dashboard_col_locale: 'Langue',
    dashboard_col_status: 'Statut',
    dashboard_col_missing: 'Champs manquants',
    dashboard_col_stale: 'Champs obsolètes',
    dashboard_empty: 'Aucune enquête publiée pour le moment.',
    dashboard_edit_link: 'Modifier',
    dashboard_export_action: 'Exporter',
    dashboard_import_action: 'Importer',
    dashboard_import_in_progress: 'Import en cours…',
    dashboard_import_in_progress_percent: 'Import en cours… {{percent}}%',
    dashboard_export_error: "Échec de l'export des traductions",
    dashboard_import_error: "Échec de l'import des traductions",
    dashboard_import_invalid_file: 'Seuls les fichiers JSON sont acceptés',
    dashboard_import_result_title: 'Import terminé',
    dashboard_import_updated:
      '{{investigations}} enquête(s), {{leads}} piste(s) et {{facts}} fait(s) mis à jour.',
    dashboard_import_skipped_title: "Éléments ignorés (supprimés depuis l'export)",
    dashboard_import_errors_title: "Certains éléments n'ont pas pu être importés",
    dashboard_import_close: 'Fermer',
    detail_investigation_title: "Détail de l'enquête",
    detail_investigation_subtitle: 'Complétude des traductions par piste.',
    detail_lead_title: 'Détail de la piste',
    detail_lead_subtitle: 'Complétude des traductions par fait.',
    detail_col_lead: 'Piste',
    detail_col_fact: 'Fait',
    detail_row_investigation_own: "Champs de l'enquête",
    detail_row_lead_own: 'Champs de la piste',
    detail_leads_empty: 'Cette enquête ne comporte aucune piste pour le moment.',
    detail_facts_empty: 'Cette piste ne comporte aucun fait pour le moment.',
    detail_back_to_dashboard: 'Retour au tableau de bord',
    detail_back_to_investigation: "Retour à l'enquête",
    detail_not_found: 'Introuvable.',
    detail_edit_lead_aria: 'Modifier la piste {{title}}',
    detail_edit_fact_aria: 'Modifier le fait {{title}}',
  },
}
